import { Model } from '@vuex-orm/core'
import moment from 'moment'
import Category from './Category'
import Client from './Client'
import User from './User'
import { isWin } from 'w3box-utils'

export default class Task extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'tasks'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id: this.attr(null),
      title: this.attr(''),
      description: this.attr(''),
      starts_at: this.string(''),
      ends_at: this.string(''),
      owner_id: this.attr(null),
      assigned_to_id: this.attr(null),
      category_id: this.attr(null),
      client_id: this.attr(null),
      done: this.boolean(false),
    }
  }

  get category() {
    return Category.find(this.category_id)
  }

  get client() {
    return Client.find(this.client_id)
  }

  get duration() {
    const d = (moment(this.ends_at).valueOf() - moment(this.starts_at).valueOf()) / 3600000
    return isNaN(d) ? 1 : d
  }

  set duration(duration) {
    this.ends_at = moment(this.starts_at).add(duration, 'hour').format('YYYY-MM-DD HH:mm:ss')
  }

  get name() {
    return `${moment(this.starts_at).format('YY-MM-DD H:mm')}-${moment(this.ends_at).format('H:mm')} ${this.title}`
  }

  get path() {
    if(this.description) {
      const description = this.description.replace(/\/Volumes\/tapczan\//gi, 'smb://10.0.120.11/tapczan/')
      let path
      let samba = description.match(/smb:\/\/10\.0\.120\.11\/tapczan\/[^\s]+/gi)
      if(samba && samba.length) samba = samba[0]
      let windows = description.match(/z:\\[^\s]+/gi)
      if(windows && windows.length) {
        windows = windows[0]
        if(samba && description.indexOf(samba) < this.description.indexOf(windows)) {
          path = !isWin() ? samba : samba.replace(/^smb:\/\/10\.0\.120\.11\/tapczan\//i, 'Z:\\').replace(/\//g, '\\')
        }
        else {
          path = isWin() ? windows : windows.replace(/^z:\\/i, 'smb://10.0.120.11/tapczan/').replace(/\\/g, '/')
        }
      }
      return path
    }
  }

  get owner() {
    return User.find(this.owner_id)
  }

  get url() {
    if(this.description) {
      const links = this.description.match(/(https?:\/\/[^\s]+)/g)
      if(links && links.length) return links[0]
    }
  }

  get week_id() {
    return this.starts_at
  }

  duplicate() {
    const task = new Task()
    var fields = this.$fields()
    Object.keys(fields).forEach(key => {
      if(key == 'id') return
      var value = this[key]
      task[key] = value
    })
    return task
  }

  isEmpty() {
    return !this.title || !this.client_id
  }

  isSpecial() {
    return this.administration || this.creative || this.supervisor
  }

  toJSON() {
    const data = {}
    var fields = this.$fields()
    Object.keys(fields).forEach(key => {
      var value = this[key]
      if(key == 'id' && isNaN(value)) return
      data[key] = value
    })
    return data
  }

  toString() {
    return `${this.id}: ${moment(this.starts_at).format('YY-MM-DD H:mm')}-${moment(this.ends_at).format('H:mm')}`
  }

  // moveTo(starts_at) {
  //   console.log('moveTo', this.id, this.title, 'from', this.starts_at, 'to', starts_at);
  //   const ends_at = moment(moment(starts_at).valueOf() + this.duration * 3600000).format('YYYY-MM-DD HH:mm:ss')
  //   return Task.update({
  //     where: this.id,
  //     data: {
  //       starts_at,
  //       ends_at,
  //     }
  //   })
  // }
}